import { useTranslation } from 'react-i18next';

import { ImageUploadCrop as ValwinFactoImageUploadCrop } from '@valwin/facto/components';

type ImageUploadCropDialogProps = {
  title?: string;
  actionButtonLabels?: {
    apply?: string;
    reset?: string;
  };
};

const ImageUploadCropDialog = ({
  title,
  actionButtonLabels,
}: Partial<ImageUploadCropDialogProps>) => {
  const { t } = useTranslation();

  return (
    <ValwinFactoImageUploadCrop.Dialog
      title={title ?? t('imageUploadCrop dialogTitle')}
      actionButtonLabels={{
        apply: actionButtonLabels?.apply ?? t('imageUploadCrop apply'),
        reset: actionButtonLabels?.reset ?? t('imageUploadCrop reset'),
      }}
    />
  );
};

export const ImageUploadCrop = {
  Root: ValwinFactoImageUploadCrop.Root,
  Preview: ValwinFactoImageUploadCrop.Preview,
  Dialog: ImageUploadCropDialog,
  Trigger: ValwinFactoImageUploadCrop.Trigger,
};
